// displayPhone shows a stored (E.164) number the way people in the UK write
// it: "+447700900123" as "07700 900123", "+442079460958" as "020 7946 0958".
// A number from elsewhere stays international, grouped for reading.
export function displayPhone(phone: string | null | undefined): string {
  const text = (phone ?? '').trim()
  if (!text) return ''
  const digits = text.replace(/\D/g, '')
  let national = ''
  if (text.startsWith('+44') || (text.startsWith('0044') && digits.length > 4)) {
    national = digits.slice(text.startsWith('+') ? 2 : 4)
  } else if (digits.startsWith('0') && digits.length === 11) {
    national = digits.slice(1)
  }
  if (national.length === 10) {
    if (national.startsWith('7') || national.startsWith('8')) return `0${national.slice(0, 4)} ${national.slice(4)}`
    if (national.startsWith('2')) return `0${national.slice(0, 2)} ${national.slice(2, 6)} ${national.slice(6)}`
    if (/^1\d1|^11/.test(national)) return `0${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`
    return `0${national.slice(0, 4)} ${national.slice(4)}`
  }
  return text
}

// telHref is the tel: link for a stored number: E.164 as stored, so it dials
// from anywhere.
export function telHref(phone: string): string {
  const text = phone.trim()
  if (text.startsWith('+')) return `tel:+${text.replace(/\D/g, '')}`
  return `tel:+${whatsappNumber(text)}`
}

// whatsappNumber turns a stored phone number into what wa.me needs: the
// full international number, digits only, no leading zero or '+'.
//
// Clients are entered in local UK format (07700 900123), so a plain digit
// strip produces an invalid wa.me link — WhatsApp requires the country
// code in place of the leading 0. A number already given with a '+' is
// assumed to already carry its own country code.
export function whatsappNumber(phone: string): string {
  const digits = phone.replace(/\D/g, '')
  if (phone.trim().startsWith('+')) return digits
  if (digits.startsWith('0')) return `44${digits.slice(1)}`
  return digits
}
